module.exports = __webpack_public_path__ + "static/img/05bg@2x.7ca244e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toolbar/05bg@2x.png
// module id = 5ULV
// module chunks = 1